





export default {
  name: 'IconContainer',
};
